<template>
  <div class="staker-stake">
    
    <div class="overview overview-bottom">
      <div class="rtitle">
        <div class="icon">
          <img src="../../assets/stafi.png" />
        </div>
        <div class="rtitle-text">
          rFIS
        </div>
      </div>
      <div class="rstatus">
        <div class="amount">
          {{ rTokenAmountShow }}
        </div>
        <div class="operation-btn btn-active" @click="unbond">
          Redeem
        </div>
        <div class="operation-btn operation-btn2 btn-active" @click="uniTrade">
          Trade
        </div>
      </div>
      <div class="rdesc">
        Your current staked FIS is {{ stakedToken }}
        <span v-if="unbondingStatus==1">, unbonding FIS is {{ unbondingToken }}</span>
      </div>
    </div>

    <div class="overview">
      <div class="rtitle">
        <div class="icon">
          <img src="../../assets/stafi.png" />
        </div>
        <div class="rtitle-text">
          rFIS / FIS
        </div>
      </div>
      <div class="rstatus">
        <div class="amount">
          {{ ratioShow }}
        </div>
        <div class="operation-btn operation-btn3 btn-active" @click="$emit('stake')">
          Stake
        </div>
      </div>
      <div class="rdesc">
        Updated every 6 hours
      </div>
    </div>

  </div>
</template>

<script>
import { setTimeout } from 'timers';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import NumberUtil from '../../util/numberUtil.js';
import LocalStorage from '../../util/localStorage.js';
import Api from '../../util/SubstrateApi.js';
import {
  web3Enable,
  web3FromSource,
} from '@polkadot/extension-dapp';

const defaultAmount = '--';
const defaultRatio = '--';

export default {
  name: 'stakerStaked',
  data() {
    let lang = window.localStorage.getItem('lang');
    let address = '';
    let rTokenAmount = defaultAmount;
    let rTokenAmountShow = defaultAmount;
    return {
      lang: lang,
      address: address,
      ratio: defaultRatio,
      ratioShow: defaultRatio,
      rTokenAmount: rTokenAmount,
      rTokenAmountShow: rTokenAmountShow,
      stakedToken: '--',
      unbondingStatus: 0,
      unbondingToken: '',
      currentEra: 0
    }
  },
  methods: {
    uniTrade() {
      window.open('https://info.uniswap.org/pair/0xec736F21bEa3D34F222ba101Af231B57699760F3');
    },
    calculateStakedToken() {
      if (this.rTokenAmount != defaultAmount && this.ratio != defaultRatio) {
        this.stakedToken = NumberUtil.handleFisAmountToFixed(this.rTokenAmount * this.ratio);
      }
    },

    unbond() {
      this.$router.push('/fisredeem');
    }

  },

  created() {

    Api.createStafiApi().then(api => {
      api.query.staking.currentEra().then(eraData => {
        this.currentEra = eraData.toJSON();
      }).catch((error) => {});

      api.query.rTokenRate.rate(0).then(result => {
        this.ratio = NumberUtil.fisAmountToHuman(result.toJSON());

        let count = 0;
        let totalCount = 10;
        let ratioAmount = 0;
        let piece = this.ratio / totalCount;
        let interval = setInterval(() => {
          count++;
          ratioAmount += piece;
          if (count == totalCount) {
            ratioAmount = this.ratio;
            window.clearInterval(interval);
          }
          this.ratioShow = NumberUtil.handleFisAmountRateToFixed(ratioAmount);
        }, 100);

      });

      let currentAccount = LocalStorage.getCurrentFisAccount();

      if (currentAccount) {
        api.query.rBalances.account(0, currentAccount).then(accountData => {
          let data = accountData.toJSON();
          if (data == null) {
            this.rTokenAmount = NumberUtil.handleFisAmountToFixed(0);
            this.rTokenAmountShow = NumberUtil.handleFisAmountToFixed(0);
            this.stakedToken = NumberUtil.handleFisAmountToFixed(0);
          } else {
            this.rTokenAmount = NumberUtil.fisAmountToHuman(data.free);
            this.rTokenAmountShow = NumberUtil.handleFisAmountToFixed(this.rTokenAmount);
            this.calculateStakedToken();
          }
        });

        api.query.rFis.pools().then(poolsData => {
          let pools = poolsData.toJSON();
          if (pools && pools.length > 0) {
            let unbondingToken = 0;

            pools.forEach(pool => {
              api.query.rFis.unbonding(currentAccount, pool).then(unbondingData => {
                let unbondings = unbondingData.toJSON();
                if (unbondings && unbondings.length > 0) {
                  unbondings.forEach(unbonding => {
                    if (this.currentEra < unbonding.era) {
                      unbondingToken += Number(unbonding.value);
                    }
                  });
                }
                if (unbondingToken > 0) {
                  this.unbondingStatus = 1;
                } else {
                  this.unbondingStatus = 0;
                }
                this.unbondingToken = NumberUtil.handleFisAmountToFixed(NumberUtil.fisAmountToHuman(unbondingToken));
              });

            });
          }
        }).catch((error) => {});

      }

    });
    
  }

  
};
</script>

<style lang="scss">

.staker-stake {

  .overview-bottom {
    padding-bottom: 50px;
    border-bottom: 1px solid #474747;
  }

  .overview {

    .rtitle {
      margin-top: 66px;
      display: flex;

      .icon {
        height: 36px;
        img {
          height: 100%;
        }
      }

      .rtitle-text {
        margin-left: 10px;
        font-size: 30px;
        font-weight: bold;
      }
    }

    .rstatus {
      display: flex;
      margin-top: 20px;
      margin-left: 56px;

      .amount {
        font-size: 30px;
        color: #00F3AB;
        font-weight: bold;
        width: 280px;
      }

      .operation-btn {
        cursor: pointer;
        width: 69px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        color: #23292F;
        font-weight: bold;
        background-color: #00F3AB;
        opacity: 0.4;
        border-radius: 13px;
        text-align: center;
      }

      .operation-btn2 {
        margin-left: 11px;
      }

      .operation-btn3 {
        margin-left: 74px;
      }

      .btn-active {
        opacity: 1;
      }
    }

    .rdesc {
      margin-top: 50px;
      margin-left: 56px;
      font-size: 16px;
      color: #C4C4C4;
      width: 400px;
    }
  
  }

}
  
</style>